export const Map = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.83647L9.89456 6.86429C10.314 6.98765 10.7623 6.97017 11.1709 6.81453L21.0758 3.04123L29 4.80217V27.1844L21.5931 25.1269C21.1709 25.0096 20.7219 25.0342 20.315 25.197L15.6286 27.0715L10.9154 28.9568L3 27.1978L3 4.83647Z" stroke="currentColor" stroke-width="2"/>
<path d="M21 3V24.5" stroke="currentColor" stroke-width="2"/>
<path d="M11 7L11 29" stroke="currentColor" stroke-width="2"/>
<path d="M29 20H3" stroke="currentColor" stroke-width="2"/>
<path d="M29 12L3 12" stroke="currentColor" stroke-width="2"/>
</svg>`;
